var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import BaseButton from "@irati/ui/src/Button/styles/Base";
import RouterLink from "../../RouterLink";
export var ButtonRouterLinkUI = styled(RouterLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  position: relative;\n\n  .loader {\n    position: absolute;\n    margin: 0;\n  }\n"], ["\n  ", "\n\n  position: relative;\n\n  .loader {\n    position: absolute;\n    margin: 0;\n  }\n"])), BaseButton);
export var ChildWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  visibility: ", ";\n"], ["\n  visibility: ", ";\n"])), function (_a) {
    var processing = _a.processing;
    return (processing ? "hidden" : "visible");
});
var templateObject_1, templateObject_2;
